module.exports = __webpack_public_path__ + "media/36.66507fbd.mp3";